<div class="col-md-12">
  <div class="card">
    <div class="card-content"> 
      <div class="fixed-table-container">          
        <div class="fixed-table-body">
          <form *ngIf="settingsForm" [formGroup]="settingsForm" (ngSubmit)="save()">
            <table class="table">
              <tbody>
                <tr *ngIf="mode === 'edit'">
                  <td colspan="3" class="text-end">
                    <button type="submit" class="btn btn-primary" [disabled]="settingsForm.invalid">Save</button>
                    <button type="button" class="btn btn-secondary ms-2" (click)="cancel()">Cancel</button>
                  </td>
                </tr>
                <tr *ngIf="mode === 'display'">
                  <td colspan="3" class="text-end">
                    <button type="button" class="btn btn-outline-primary" (click)="edit()">Edit</button>
                  </td>
                </tr>
                <tr>
                  <td class="column column-label">
                    <label for="price-per-square-metre">
                      Price per Square Metre
                    </label>
                  </td>
                  <td class="column column-input" *ngIf="settingsForm.get('pricePerSqM') as pricePerSqM">
                    <div [ngClass]="{ 
                      'has-error': pricePerSqM.invalid && (pricePerSqM.touched || pricePerSqM.dirty) 
                    }">                    
                    <input
                      *ngIf="mode === 'edit'"
                      class="form-control"                      
                      id="price-per-square-metre"
                      type="number"
                      formControlName="pricePerSqM"
                      min="0"
                      step="0.01"
                    >   
                  </div>                 
                    <div *ngIf="mode === 'display'">
                      {{ settingsForm.get('pricePerSqM')?.value | currency:'GBP':'symbol'  }}                        
                    </div>                    
                  </td>
                  <td class="column column-validation">
                    <div class="validation-message" *ngIf="settingsForm.get('pricePerSqM') as pricePerSqM">
                      <small *ngIf="(pricePerSqM.touched || pricePerSqM.dirty) && pricePerSqM.errors?.['required']">
                        Required
                      </small>                     
                      <small *ngIf="(pricePerSqM.touched || pricePerSqM.dirty) && pricePerSqM.errors?.['pattern']">
                        Must be a positive number with up to 2 decimal places
                      </small>
                    </div>
                  </td>
                  <td class="spacer-column">

                  </td>
                </tr>
              </tbody>
            </table>
          </form>
        </div>
      </div>            
    </div>
  </div>
</div>  
